import config from '../config'
import query from '../api/BaseApi'

export default class Movie {
  constructor() {
    this.host = config.movie_host;
    this.model = 'movie';
  }
  async query({ host = this.host, method, urlParams, bodyPayload, pathPrefix = '/api/v1/', model = this.model, path = '', headers = null }) {
    return await query({
      host: host,
      method: method,
      urlParams: urlParams,
      bodyPayload: bodyPayload,
      pathPrefix: pathPrefix,
      model: model,
      path: path,
      headers: headers,
    })
  }
  //index
  async getMovieChartData(params = { week_date: '', crowd: 'overall' }) {
    return await this.query({
      method: 'GET',
      path: "/chart",
      urlParams: params,
    })
  }
  //graph_container indicator_chart
  //params:mainMovie: undefined,movie_ids: undefined,crowd: undefined,offset: undefined,indicator: true
  async getIndicatorChartData(params = {}) {
    return await this.query({
      method: 'GET',
      path: "/indicator",
      urlParams: params,
    })
  }
  //graph_container primary_div_chart
  //params:mainMovie: undefined,movie_ids: undefined,crowd: undefined,offset: undefined,is_div_me: true
  async getPrimarydivChartData(params = {}) {
    return await this.query({
      method: 'GET',
      path: "/primary_div",
      urlParams: params,
    })
  }
  async getMovieListByDate(params = { week_date: '', crowd: 'overall' }) {
    return await this.query({
      method: 'GET',
      path: "/by_date",
      urlParams: params,
    })
  }
  async getMovieScheduler() {
    return await this.query({
      method: 'GET',
      path: "/scheduler",
    })
  }
  // movieLib
  async getMovieByTitle(params = { title: "" }) {
    return await this.query({
      method: 'GET',
      path: "/search",
      urlParams: params,
    })
  }
  async getMovieListMarketInfo(bodyPayload = { ids: [], crowd: [], offset: "", tag_ids: [], indicator: undefined }) {
    return await this.query({
      method: 'POST',
      bodyPayload: bodyPayload,
    })
  }
  async getMovieListBasicInfo(bodyPayload = { ids: [] }) {
    return await this.query({
      path: "/basic",
      method: 'POST',
      bodyPayload: bodyPayload,
    })
  }
  async getSingleMovieBasicInfo(bodyPayload = { id: undefined }) {
    return await this.query({
      path: "/simple_indicator",
      method: 'GET',
      urlParams: bodyPayload,
    })
  }

  async has_result(bodyPayload = { ids: [] }) {
    return await this.query({
      path: '/has_result',
      method: 'POST',
      bodyPayload: bodyPayload,
    })
  }

  async exportChartData(bodyPayload = { ids: [], crowd: [], offset: "", indicator: undefined, is_div_me: true }) {
    return await this.query({
      method: 'POST',
      path: '/export',
      bodyPayload: bodyPayload,
    })
  }
  async exportTotalData(bodyPayload = { ids: [], movie_id: undefined, crowd: undefined, indicator: undefined }) {
    return await this.query({
      method: 'POST',
      path: '/export_all',
      bodyPayload: bodyPayload,
    })
  }


}